import { useEffect, useState } from "react";
import { fetchActivity } from "@/lib/api";

export default function useActivity(slug) {
  const [activity, setActivity] = useState(null);
  const [status, setStatus] = useState("loading"); // loading | ok | notfound | error

  useEffect(() => {
    let active = true;
    setStatus("loading");
    fetchActivity(slug)
      .then((data) => {
        if (!active) return;
        setActivity(data);
        setStatus("ok");
      })
      .catch((err) => {
        if (!active) return;
        if (err?.response?.status === 404) setStatus("notfound");
        else setStatus("error");
      });
    return () => {
      active = false;
    };
  }, [slug]);

  return { activity, status };
}
